import React from 'react';

import {assert} from 'Asserts';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getTypedStudyAdapter} from 'studies/typed/TypedStudyAdapters';

export default function StudyDesignView({
  studyId,
  studyType,
}: {
  studyId: string;
  studyType: StudyType;
}): JSX.Element | null {
  const adapter = getTypedStudyAdapter(studyType);
  const {tab: StudyDesignTabContents} = adapter.design.ui;
  const {allowReturnToDesignPhase} = adapter;

  assert(
    StudyDesignTabContents != null,
    `Unexpectedly rendered study design tab for a study type without a design tab: ${studyType}`,
    {studyId, studyType}
  );
  return (
    <StudyDesignTabContents
      studyId={studyId}
      viewer={false}
      locked={
        // TODO(BNCH-124297): Query if the study design is writable.
        false
      }
      allowReturnToDesignPhase={allowReturnToDesignPhase}
    />
  );
}
